import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiFetch, apiSearch } from '../modules/utility';

const apiBase = 'userAssignment';
const listName = `${apiBase}s`;
const idField = `${apiBase}Id`;
const idsField = `${idField}s`;
const item = 'user assignment';
// const onSuccessRedirectTo = `/userAssignment/list`;

const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			dispatch,
			callback,
		});
	};
};

const searchByUser = ({ userId, callback }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.search`,
			params: {
				userIds: [userId],
				includePast: true,
			},
			dispatch,
			callback,
		});
	};
};

const get = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const end = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.end`,
			params,
			dispatch,
			callback,
		});
	};
};

const findCurrent = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.findCurrent`,
			params,
			dispatch,
			callback,
		});
	};
};

const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate: idsField,
			params,
			dispatch,
			savingMessage: `Updating ${item}...`,
			savedMessage: `${_.capitalize(item)} updated successfully. 
				Click continue to return to the schedule.`,
			// onSuccessRedirectTo,
			delay: 350,
			callback,
		});
	};
};

const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			savingMessage: `Updating ${item}...`,
			savedMessage: `${_.capitalize(item)} updated successfully. 
				Click continue to return to the schedule.`,
			// onSuccessRedirectTo,
			delay: 350,
			callback,
		});
	};
};

const mapStateToProps = (state, ownProps) => {
	const newState = {};

	const userAssignmentId = ownProps[idField]
		? ownProps[idField]
		: _.get(ownProps, ['match', 'params', idField]);

	newState[apiBase] = _.get(state.maps, [apiBase, userAssignmentId]);

	newState[listName] = [];
	if (state.lists[idsField]) {
		newState[listName] = _.map(state.lists[idsField], (id) => state.maps[apiBase][id]);
	}

	newState.locationMap = state.maps.location;
	newState.shiftMap = state.maps.shift;
	newState.equipmentMap = state.maps.equipment;
	newState.userMap = state.maps.user;
	return newState;
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			searchUserAssignments: search,
			searchUserAssignmentsByUser: searchByUser,
			getUserAssignment: get,
			addUserAssignment: add,
			updateUserAssignment: update,
			endUserAssignment: end,
			findCurrentAssignment: findCurrent,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
